import { api } from "../client";

export const getISP = (ip) => {
  return api.get(`/readytowork/isp/${ip}`);
};
